import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import {
	GetGameSettingsParams,
	GetGameSettingsSuccessPayload,
	GetGameVariantParams,
	GetGameVariantSuccessPayload,
} from "./game-variant.model";

export const ACTION_PREFIX = "[Game Variant]";
export const GAME_VARIANT_ACTION_TYPE = {
	get: `${ACTION_PREFIX} Get`,
	getSettings: `${ACTION_PREFIX} Get Settings`,
	getSuccess: `${ACTION_PREFIX} Get Success`,
	getSettingsSuccess: `${ACTION_PREFIX} Get Settings Success`,
	getFail: `${ACTION_PREFIX} Get Fail`,
	clear: `${ACTION_PREFIX} Clear ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class GameVariantAction {
	get(payload: GetGameVariantParams): ActionWithPayload {
		return {
			type: GAME_VARIANT_ACTION_TYPE.get,
			payload,
		};
	}

	getSettings(payload: GetGameSettingsParams): ActionWithPayload {
		return {
			type: GAME_VARIANT_ACTION_TYPE.getSettings,
			payload,
		};
	}

	getSettingsSuccess(payload: GetGameSettingsSuccessPayload): ActionWithPayload {
		return {
			type: GAME_VARIANT_ACTION_TYPE.getSettingsSuccess,
			payload,
		};
	}

	getSuccess(payload: GetGameVariantSuccessPayload): ActionWithPayload {
		return {
			type: GAME_VARIANT_ACTION_TYPE.getSuccess,
			payload,
		};
	}

	getFail(error: AppError): ActionWithPayload {
		return {
			type: GAME_VARIANT_ACTION_TYPE.getFail,
			payload: error,
		};
	}

	clear(): Action {
		return { type: GAME_VARIANT_ACTION_TYPE.clear };
	}
}
